import { FEATURES, MODULES } from '../constants/template-info'

import eraseCookie from './eraseCookie'
import isBrowser from './isBrowser'
import { captureException } from './sentryUtil'
import setCookie from './setCookie'

const getCookie = (cname: string): string | undefined => {
  if (!isBrowser()) return undefined
  const name = `${cname}=`
  try {
    const decodedCookie = document.cookie
    const cookiesArray = decodedCookie.split(';')
    for (let cookie of cookiesArray) {
      cookie = cookie.trimStart()
      if (cookie.startsWith(name)) {
        return cookie.substring(name.length, cookie.length)
      }
    }
  } catch (error) {
    captureException(error, {
      module: MODULES.UNKNOWN,
      feature: FEATURES.GET_COOKIE,
    })
  }
  return undefined
}

export const areCookiesEnabled = () => {
  let isEnabled = false
  const testCookieName = 'testName'
  const testCookieValue = 'testValue'
  setCookie(testCookieName, testCookieValue, 1)
  if (getCookie(testCookieName) === testCookieValue) {
    isEnabled = true
    eraseCookie(testCookieName)
  } else {
    captureException('Cookie storage is not enabled', {
      module: MODULES.COOKIE_STORAGE,
      feature: FEATURES.GET_COOKIE,
    })
  }
  return isEnabled
}

export default getCookie
